import * as React from 'react';
import { translate } from 'react-i18next';

class HomeFooterCopyrights extends React.Component<any, any> {

    constructor(props) {
        super(props);
    }

	render() {

        var data_social: any = {};

        if(sessionStorage.getItem('data_social')) {
            data_social = JSON.parse(sessionStorage.getItem('data_social'));
        }

		return (
			<div>
                <div className="clearfix"></div>
                <div className="listSocial">
                    <div className="container">
                        <div className="row ">
                            <div className="col-sm-12">
                                <div className="social text-left">
                                    <div className="listSocial-c">
                                        {data_social.social_facebook != null && data_social.social_facebook != '' ?
                                        <a target="_blank" href={data_social.social_facebook}><img src={require('../img/img-social1.png')} height="30"/></a> : ''}
                                        {data_social.social_instagram != null && data_social.social_instagram != '' ?
                                        <a target="_blank" href={data_social.social_instagram}><img src={require('../img/img-social2.png')} height="30"/></a> : '' }
                                        {data_social.social_youtube != null && data_social.social_youtube != '' ?
                                        <a target="_blank" href={data_social.social_youtube}><img src={require('../img/img-social3.png')} height="23"/></a> : '' }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="copyright">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 text-left">
                                <div className="info-copyright ">
                                    ©2007 <span className="txtCafeCong">
	                                <img src={require('../img/congcafe-txt.png')} height="35"/></span> Co., Ltd | All Rights
                                    Reserved.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="overlay"></div>
			</div>
		);
	}
}

export default translate('translations')(HomeFooterCopyrights);



// WEBPACK FOOTER //
// ./src/components/HomeFooterCopyrights.tsx